import cn from 'classnames'
import React, { ComponentProps } from 'react'

export type DigitalCreditCardFlyoutSvgProps = ComponentProps<'svg'>

export default function DigitalCreditCardFlyoutSvg(
  props: DigitalCreditCardFlyoutSvgProps,
) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('DigitalCreditCardFlyoutSvg', className)}
      width="118"
      height="102"
      viewBox="0 0 118 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    >
      <g clipPath="url(#clip0_22752_69081)">
        <g filter="url(#filter0_d_22752_69081)">
          <path
            d="M59 96.5189C84.9574 96.5189 106 75.3625 106 49.2648C106 23.1671 84.9574 2.01074 59 2.01074C33.0426 2.01074 12 23.1671 12 49.2648C12 75.3625 33.0426 96.5189 59 96.5189Z"
            fill="black"
          />
        </g>
        <path
          d="M59 96.5189C84.9574 96.5189 106 75.3625 106 49.2648C106 23.1671 84.9574 2.01074 59 2.01074C33.0426 2.01074 12 23.1671 12 49.2648C12 75.3625 33.0426 96.5189 59 96.5189Z"
          fill="#F2F3F7"
        />
        <g filter="url(#filter1_d_22752_69081)">
          <path
            d="M82.932 4.78067L4.05959 43.2493C1.95669 44.275 1.08341 46.8112 2.10906 48.9141L24.9701 95.7861C25.9957 97.889 28.5319 98.7623 30.6348 97.7366L109.507 59.2679C111.61 58.2423 112.483 55.7061 111.458 53.6032L88.5968 6.7312C87.5711 4.6283 85.0349 3.75502 82.932 4.78067Z"
            fill="black"
          />
        </g>
        <path
          d="M86.1744 3.19927L4.20891 43.1765C2.02354 44.2424 1.11601 46.878 2.18189 49.0634L25.9394 97.7735C27.0053 99.9589 29.6409 100.866 31.8263 99.8005L113.792 59.8233C115.977 58.7574 116.885 56.1218 115.819 53.9364L92.0613 5.22628C90.9954 3.04092 88.3598 2.13339 86.1744 3.19927Z"
          fill="#21BA99"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.555 55.4918L51.9583 40.1754C52.4763 39.9228 52.6914 39.2981 52.4387 38.7801L51.7873 37.4445C51.5347 36.9265 50.91 36.7114 50.392 36.964L18.9888 52.2805C18.4708 52.5331 18.2557 53.1578 18.5083 53.6757L19.1598 55.0114C19.4124 55.5293 20.0371 55.7444 20.555 55.4918Z"
          fill="url(#paint0_linear_22752_69081)"
        />
        <circle
          cx="32.5966"
          cy="78.4451"
          r="1.80456"
          transform="rotate(-26 32.5966 78.4451)"
          fill="white"
        />
        <circle
          cx="36.9579"
          cy="76.3182"
          r="1.80456"
          transform="rotate(-26 36.9579 76.3182)"
          fill="white"
        />
        <circle
          cx="41.3202"
          cy="74.1902"
          r="1.80456"
          transform="rotate(-26 41.3202 74.1902)"
          fill="white"
        />
        <circle
          cx="48.6425"
          cy="70.6199"
          r="1.80456"
          transform="rotate(-26 48.6425 70.6199)"
          fill="white"
        />
        <circle
          cx="53.0038"
          cy="68.493"
          r="1.80456"
          transform="rotate(-26 53.0038 68.493)"
          fill="white"
        />
        <circle
          cx="57.3651"
          cy="66.366"
          r="1.80456"
          transform="rotate(-26 57.3651 66.366)"
          fill="white"
        />
        <circle
          cx="64.6864"
          cy="62.7947"
          r="1.80456"
          transform="rotate(-26 64.6864 62.7947)"
          fill="white"
        />
        <circle
          cx="69.0478"
          cy="60.6678"
          r="1.80456"
          transform="rotate(-26 69.0478 60.6678)"
          fill="white"
        />
        <circle
          cx="73.4101"
          cy="58.5398"
          r="1.80456"
          transform="rotate(-26 73.4101 58.5398)"
          fill="white"
        />
        <circle
          cx="80.7314"
          cy="54.9686"
          r="1.80456"
          transform="rotate(-26 80.7314 54.9686)"
          fill="white"
        />
        <circle
          cx="85.0927"
          cy="52.8416"
          r="1.80456"
          transform="rotate(-26 85.0927 52.8416)"
          fill="white"
        />
        <circle
          cx="89.454"
          cy="50.7146"
          r="1.80456"
          transform="rotate(-26 89.454 50.7146)"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_22752_69081"
          x="7"
          y="-0.989258"
          width="104"
          height="104.508"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_22752_69081"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_22752_69081"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_22752_69081"
          x="-1.20711"
          y="2.42606"
          width="115.982"
          height="99.589"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.962264" />
          <feGaussianBlur stdDeviation="1.4434" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_22752_69081"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_22752_69081"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_22752_69081"
          x1="31.5715"
          y1="48.1311"
          x2="58.5577"
          y2="34.969"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4FFF9" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_22752_69081">
          <rect width="118" height="102" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
